import _ from 'lodash';
import LocalStorageHelper from './local_storage';

const AuthHelper = {
	isAuthenticated() {
		const token = LocalStorageHelper.getToken();
		return !_.isEmpty(token);
	}
};

export default AuthHelper;
